import React, { useEffect } from 'react'

export const ContactForm:React.FC = () => {
  useEffect(()=> {
    window.hbspt.forms.create({
      region: "na1",
      portalId: "9053430",
      formId: "5320f705-a3de-4e9a-a039-0e4de63cabad",
      target: '#hubspot-contact-form'
    }); 
  }, [])
  return (
    <div id="hubspot-contact-form" />
  )
}